import React from 'react'
import { IsAuthorizeUser } from '../../lib/authenticationLibrary';
import Unauthorize from '../../pages/unauthorize/Unauthorize';


const AuthorizationWrap = (props) => {
    return (
        <>
            {
                (IsAuthorizeUser(props.authorizeRoleType)) ?
                    props.children :
                    <Unauthorize />
            }
        </>
    );
}

export default AuthorizationWrap